import moment from 'moment';

export function formatDate(dateString, format) {
  return moment(dateString, 'YYYY-MM-DD hh:mm:ss A').format(format || 'lll');
}
